export enum FormulaType {
    mobilePush = 'push',
    webPush = 'web_push',
    sms = 'sms',
    whatsapp = 'whatsapp',
    email = 'email',
    contentCards = 'content_cards',
    surface = 'surface',
}
